import React, { useEffect, useRef, useState } from 'react';

import { Html } from '@react-three/drei';
import { NavigationMarker } from '../../NavigationMarker';

interface ContraMissionMarkerProps {
  position: [number, number, number];
  playerPosition: [number, number, number];
  onEnterMission: () => void;
}

export const ContraMissionMarker: React.FC<ContraMissionMarkerProps> = ({
  position,
  playerPosition,
  onEnterMission,
}) => {
  const [isPlayerNear, setIsPlayerNear] = useState(false);
  const activationDistance = 5; // Distance in units at which player can activate the mission
  const lastDistanceRef = useRef(999);

  // Check distance between player and marker
  useEffect(() => {
    if (!playerPosition) return;

    const dx = playerPosition[0] - position[0];
    const dz = playerPosition[2] - position[2];
    const distance = Math.sqrt(dx * dx + dz * dz);

    lastDistanceRef.current = distance;

    // Update if player is in activation range
    setIsPlayerNear(distance <= activationDistance);
  }, [playerPosition, position, activationDistance]);

  // Handle marker click - only activate if player is near
  const handleMarkerClick = () => {
    if (isPlayerNear) {
      onEnterMission();
    } else {
      console.log('Player too far to activate mission');
    }
  };

  // Handle keypress for mission activation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'e' && isPlayerNear) {
        console.log('Activating mission via E key');
        onEnterMission();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isPlayerNear, onEnterMission]);

  // Render the marker with Contra specific styling
  return (
    <>
      {/* Use the base NavigationMarker with red color theme for Contra */}
      <group onClick={handleMarkerClick}>
        <NavigationMarker
          position={position}
          scale={1.2} // Make it slightly larger for emphasis
        />

        {/* Prompt to enter mission when player is near */}
        {isPlayerNear && (
          <Html position={[position[0], position[1] + 4, position[2]]}>
            <div
              style={{
                background: 'rgba(0,0,0,0.7)',
                color: 'white',
                padding: '4px',
                borderRadius: '5px',
                textAlign: 'center',
                pointerEvents: 'none',
                width: '280px',
              }}
            >
              Press E or click to enter mission
            </div>
          </Html>
        )}
      </group>
    </>
  );
};
